import { UserResponse } from "../types";
import { axios } from "lib/axios";
import { AxiosError } from "axios";

export type LoginCredentialsDTO = {
  username: string;
  password: string;
};

export const loginFn = async (
  data: LoginCredentialsDTO
): Promise<UserResponse> => {
  try {
    const response = await axios.post("/auth/login", data);
    return response.data;
  } catch (error) {
    if (error instanceof AxiosError) {
      console.error(error.response?.data.error);
    }
    return error as any;
  }
};
